// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import { buildAutoPatternFromParts, createCodeGeneratorPart, createDefaultCodeGeneratorData } from './definitions';

const normalizePartInput = (part = {}) => ({
    ...createCodeGeneratorPart(part?.part_type || 'static_value'),
    partType: part?.part_type || 'static_value',
    value: part?.value ?? '',
    direction: part?.direction || 'asc',
    interval: part?.interval || 'none',
    length: part?.length ?? '',
    format: part?.format || 'Y',
    timezone: part?.timezone || '',
    fieldName: part?.field_name || '',
    externalEntityFieldName: part?.external_entity_field_name || ''
});

const normalizePartOutput = (part = {}) => {
    const normalizedPart = { part_type: part?.partType };

    switch (part?.partType) {
        case 'static_value':
            normalizedPart.value = part?.value ?? '';
            break;
        case 'counter':
            normalizedPart.direction = part?.direction || 'asc';
            normalizedPart.interval = part?.interval || 'none';
            if (part?.length !== '' && part?.length !== null && part?.length !== undefined) {
                normalizedPart.length = Number(part.length);
            }
            break;
        case 'date':
            normalizedPart.format = part?.format || 'Y';
            if (part?.timezone) {
                normalizedPart.timezone = part.timezone;
            }
            break;
        case 'field_value_local':
            normalizedPart.field_name = part?.fieldName || '';
            break;
        case 'field_value_external':
            normalizedPart.field_name = part?.fieldName || '';
            normalizedPart.external_entity_field_name = part?.externalEntityFieldName || '';
            break;
        default:
            break;
    }

    return normalizedPart;
};

export const processEntityInput = (values) => {
    const normalizedValues = { ...values, ...processEntityInputMain(values) };
    const defaultData = createDefaultCodeGeneratorData();
    const data = normalizedValues?.data || {};
    const parts = Object.values(data?.parts || {}).map((part) => normalizePartInput(part));

    return {
        ...normalizedValues,
        data: {
            ...defaultData,
            applyGenerator: data?.apply_generator ?? defaultData.applyGenerator,
            targetFieldName: data?.target_field_name || defaultData.targetFieldName,
            generatorMode: data?.generator_mode || defaultData.generatorMode,
            pattern: data?.pattern || (parts.length > 0 ? buildAutoPatternFromParts(parts) : defaultData.pattern),
            glue: data?.glue ?? defaultData.glue,
            parts: parts.length > 0 ? parts : defaultData.parts
        }
    };
};

export const processEntityOutput = (values) => {
    const parts = Array.isArray(values?.data?.parts) ? values.data.parts : [];
    const generatorMode = values?.data?.generatorMode || 'pattern_replacement';

    return {
        ...values,
        ...processEntityOutputMain(values),
        data: {
            apply_generator: Boolean(values?.data?.applyGenerator),
            target_field_name: values?.data?.targetFieldName || 'code',
            generator_mode: generatorMode,
            ...(generatorMode === 'pattern_replacement'
                ? { pattern: values?.data?.pattern || buildAutoPatternFromParts(parts) }
                : { glue: values?.data?.glue ?? '-' }),
            parts: parts.reduce((result, part, index) => ({ ...result, [`p${index + 1}`]: normalizePartOutput(part) }), {})
        }
    };
};
